export const userGuideData = {
  title: "es.setting_guide.title",
  introduction: {
    content: [
      "es.setting_guide.introduction.content.0",
      "es.setting_guide.introduction.content.1"
    ],
    requirements: [
      {
        title: "es.setting_guide.introduction.requirements.0.title",
        description:
          "es.setting_guide.introduction.requirements.0.description"
      },
      {
        title: "es.setting_guide.introduction.requirements.1.title",
        description:
          "es.setting_guide.introduction.requirements.1.description"
      },
      {
        title: "es.setting_guide.introduction.requirements.2.title",
        description:
          "es.setting_guide.introduction.requirements.2.description"
      }
    ],
    tips: [
      "es.setting_guide.introduction.tips.0",
      "es.setting_guide.introduction.tips.1",
      "es.setting_guide.introduction.tips.2"
    ]
  },
  steps: [
    {
      platform: "iOS",
      title: "es.setting_guide.steps.0.title",
      methods: [
        {
          title: "es.setting_guide.steps.0.methods.0.title",
          steps: [
            "es.setting_guide.steps.0.methods.0.steps.0",
            "es.setting_guide.steps.0.methods.0.steps.1",
            "es.setting_guide.steps.0.methods.0.steps.2",
            "es.setting_guide.steps.0.methods.0.steps.3",
            "es.setting_guide.steps.0.methods.0.steps.4",
            "es.setting_guide.steps.0.methods.0.steps.5"
          ]
        },
        {
          title: "es.setting_guide.steps.0.methods.1.title",
          steps: [
            "es.setting_guide.steps.0.methods.1.steps.0",
            "es.setting_guide.steps.0.methods.1.steps.1",
            "es.setting_guide.steps.0.methods.1.steps.2",
            "es.setting_guide.steps.0.methods.1.steps.3",
            "es.setting_guide.steps.0.methods.1.steps.4",
            "es.setting_guide.steps.0.methods.1.steps.5",
            "es.setting_guide.steps.0.methods.1.steps.6"
          ]
        }
      ]
    },
    {
      platform: "Android",
      title: "es.setting_guide.steps.1.title",
      methods: [
        {
          title: "es.setting_guide.steps.1.methods.0.title",
          steps: [
            "es.setting_guide.steps.1.methods.0.steps.0",
            "es.setting_guide.steps.1.methods.0.steps.1",
            "es.setting_guide.steps.1.methods.0.steps.2",
            "es.setting_guide.steps.1.methods.0.steps.3",
            "es.setting_guide.steps.1.methods.0.steps.4"
          ]
        },
        {
          title: "es.setting_guide.steps.1.methods.1.title",
          steps: [
            "es.setting_guide.steps.1.methods.1.steps.0",
            "es.setting_guide.steps.1.methods.1.steps.1",
            "es.setting_guide.steps.1.methods.1.steps.2",
            "es.setting_guide.steps.1.methods.1.steps.3",
            "es.setting_guide.steps.1.methods.1.steps.4",
            "es.setting_guide.steps.1.methods.1.steps.5"
          ]
        }
      ]
    }
  ],
  activation: {
    ios: [
      "es.setting_guide.activation.ios.0",
      "es.setting_guide.activation.ios.1",
      "es.setting_guide.activation.ios.2"
    ],
    android: [
      "es.setting_guide.activation.android.0",
      "es.setting_guide.activation.android.1"
    ]
  },
  deletion: {
    ios: [
      "es.setting_guide.deletion.ios.0",
      "es.setting_guide.deletion.ios.1",
      "es.setting_guide.deletion.ios.2"
    ],
    android: [
      "es.setting_guide.deletion.android.0",
      "es.setting_guide.deletion.android.1",
      "es.setting_guide.deletion.android.2",
      "es.setting_guide.deletion.android.3"
    ]
  }
}